<span class="preserve-line-break">
  <span data-cy="read-more-comment" appConvertLink [inputText]="collapsedContent"></span>
  @if (isCollapsed) {
    <span>...</span>
  }
  &nbsp;
  @if (isCollapsed) {
    <span class="spen-util-link" (click)="readMore()">もっと読む</span>
  }
</span>
